import { render, staticRenderFns } from "./ContentHeader.vue?vue&type=template&id=52053898&scoped=true"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"
import style0 from "./ContentHeader.vue?vue&type=style&index=0&id=52053898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52053898",
  null
  
)

export default component.exports